<ng-container *ngIf="isLoader">
  <div class="loading-shade">
    <img src="/assets/images/loader.gif" alt="" height="90" width="90">
  </div>
</ng-container>